import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Scale } from "lucide-react";

export const WeightDialog = ({
  open, onClose,
  pendingWeightProduct, getProductPrice,
  weightInput, setWeightInput, weightInputRef,
  onConfirm, focusSearchInput,
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => {
      if (!o) {
        onClose();
        focusSearchInput();
      }
    }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Scale className="h-5 w-5 text-blue-600" /> Enter Weight (kg)
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          {pendingWeightProduct && (
            <div className="bg-slate-50 p-3 rounded-lg">
              <div className="font-semibold text-lg">{pendingWeightProduct.name}</div>
              <div className="text-sm text-slate-600">
                PLU: {pendingWeightProduct.plu_code} | R {getProductPrice(pendingWeightProduct).toFixed(2)}/kg
              </div>
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="weight-input" className="text-base">Weight in Kilograms</Label>
            <Input
              id="weight-input" ref={weightInputRef}
              type="number" value={weightInput}
              onChange={(e) => setWeightInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onConfirm();
                else if (e.key === 'Escape') onClose();
              }}
              placeholder="e.g. 1.5" min="0.001" step="0.001"
              className="text-2xl h-14 text-center font-bold" autoFocus
            />
            {weightInput && parseFloat(weightInput) > 0 && pendingWeightProduct && (
              <div className="text-center text-lg font-semibold text-green-600 mt-2">
                Total: R {(parseFloat(weightInput) * getProductPrice(pendingWeightProduct)).toFixed(2)}
              </div>
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => { onClose(); focusSearchInput(); }}>Cancel</Button>
          <Button onClick={onConfirm} disabled={!weightInput || parseFloat(weightInput) <= 0}
            className="bg-green-600 hover:bg-green-700">
            Add to Cart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
